import { render, staticRenderFns } from "./modal-beta-welcome.vue?vue&type=template&id=7d5d5317&scoped=true"
import script from "./modal-beta-welcome.vue?vue&type=script&lang=js"
export * from "./modal-beta-welcome.vue?vue&type=script&lang=js"
import style0 from "./modal-beta-welcome.vue?vue&type=style&index=0&id=7d5d5317&prod&lang=css"
import style1 from "./modal-beta-welcome.vue?vue&type=style&index=1&id=7d5d5317&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5d5317",
  null
  
)

export default component.exports